import React from 'react'
import View from '../../../../../components/pdf/View'
import Text from '../../../../../components/pdf/Text'
import Separator from '../../../../../components/pdf/Separator'
import { Col, Grid } from '../../../../../packages/kiti/components/structure/Grid'
import { COLORS } from '@btime/constants'
import LineSeparator from '../../../../../packages/kiti/components/helpers/LineSeparator'
import { formatDate } from '@btime/helpers'
import moment from 'moment'

import { findReplyByQuestionId, getReplyValue } from '../../_helpers/pdfHelpers'
import { useServiceOrder } from '../../_load/ServiceOrderLoader'

const aditionalInfos = [
  'Coparticipação para furto, roubo, incêndio e perda total - Valor: R$ 5.000',
  'Coparticipação para pequenos danos e avarias - Valor: R$ 2.500',
  'Coparticipação para cobertura contra terceiros - Valor: R$ 1.000',
  'Perímetro máximo de rodagem: até 150km da filial de entrega',
  'Franquia de KM: 1750 por semana',
  'KM excedido da franquia: R$ 0,75 por KM',
  'Nível do combustível conforme vistoria de entrega',
  'Pagamento semanal no mesmo dia da retirada'
]

const FieldBlock = ({ label, value }) => (
  <Col style={{ flex: 1, marginBottom: 8 }}>
    <Text size={10} color="#04498fff" style={{ textTransform: 'uppercase' }}>
      {label}
    </Text>
    <Text size={11}>{value}</Text>
  </Col>
)

const Content = () => {
  const { replies, yearlyId, place } = useServiceOrder()

  const deliveryLocation = getReplyValue(findReplyByQuestionId(replies, 271)) || 'N/A'
  const returnLocation = getReplyValue(findReplyByQuestionId(replies, 272)) || 'N/A'
  const deliveryDateTime = getReplyValue(findReplyByQuestionId(replies, 273))
  const formattedDeliveryDateTime = deliveryDateTime ? formatDate('DD/MM/YYYY HH:mm', deliveryDateTime) : 'N/A'

  const returnDeliveryDateTime = deliveryDateTime
    ? moment(deliveryDateTime).add(1, 'year').format('DD/MM/YYYY HH:mm')
    : 'N/A'

  const attendant = getReplyValue(findReplyByQuestionId(replies, 275)) || 'N/A'
  const client = getReplyValue(findReplyByQuestionId(replies, 312)) || 'N/A'
  const cpf = getReplyValue(findReplyByQuestionId(replies, 293))
  const formattedCpf = cpf ? cpf?.name?.split('|')?.[0] || 'N/A' : 'N/A'
  const cnh = getReplyValue(findReplyByQuestionId(replies, 278)) || 'N/A'
  const email = getReplyValue(findReplyByQuestionId(replies, 279)) || 'N/A'
  const phone = getReplyValue(findReplyByQuestionId(replies, 280)) || 'N/A'
  const address = getReplyValue(findReplyByQuestionId(replies, 294)) || 'N/A'
  const plate = place?.name || 'N/A'
  const group = place?.resume?.split('-')?.[0] || 'N/A'
  const kmEntrega = getReplyValue(findReplyByQuestionId(replies, 282)) || 'N/A'
  const securityDeposit = getReplyValue(findReplyByQuestionId(replies, 297)) || 'N/A'
  const rentalPriceInWeeks = getReplyValue(findReplyByQuestionId(replies, 296)) || 'N/A'

  return (
    <View>
      <Separator weight={3} />

      <Text size={15} color="black" bold marginBottom={4} align="center">
        ABERTURA DO CONTRATO DE LOCAÇÃO
      </Text>

      <Separator weight={5} />

      <Grid>
        <FieldBlock label="Contrato" value={yearlyId} />
        <FieldBlock label="Local de Entrega" value={deliveryLocation} />
        <FieldBlock label="Data Hora de Entrega" value={formattedDeliveryDateTime} />
      </Grid>

      <Grid>
        <FieldBlock label="Atendente" value={attendant} />
        <FieldBlock label="Local de Devolução" value={returnLocation} />
        <FieldBlock label="Data Devolução" value={returnDeliveryDateTime} />
      </Grid>

      <LineSeparator weight={1} color={COLORS.light3} padding={4} />

      <Grid>
        <FieldBlock label="Cliente" value={client} />
        <FieldBlock label="CPF" value={formattedCpf} />
        <FieldBlock label="CNH" value={cnh} />
      </Grid>

      <Grid>
        <FieldBlock label="E-mail" value={email} />
        <FieldBlock label="" />
        <FieldBlock label="Telefone" value={phone} />
      </Grid>

      <Grid>
        <FieldBlock label="Endereço" value={address} />
        <FieldBlock label="" />
        <FieldBlock label="" />
      </Grid>

      <LineSeparator weight={1} color={COLORS.light3} padding={4} />

      <Grid>
        <FieldBlock label="Placa" value={plate} />
        <FieldBlock label="Grupo" value={group} />
        <FieldBlock label="Km Entrega" value={kmEntrega} />
      </Grid>

      <Grid>
        <FieldBlock label="Caução" value={securityDeposit} />
        <FieldBlock label="VALOR DE LOCAÇÃO EM SEMANAS" value={rentalPriceInWeeks} />
        <FieldBlock label="" />
      </Grid>

      <LineSeparator weight={1} color={COLORS.light3} padding={4} />

      <Text size={12} color="#04498fff">
        INFORMAÇÕES ADICIONAIS
      </Text>
      <Separator weight={1} />
      {aditionalInfos?.map((info, idx) => (
        <Text key={idx} size={11} style={{ textTransform: 'uppercase' }}>
          • {info}
        </Text>
      ))}
    </View>
  )
}

export default Content
